import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LmoDriver, LmoDriverService } from '~services/lmo-driver.service';
import { UserService } from '~services/user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'sa-ban-driver-dialog',
  templateUrl: './ban-driver-dialog.component.html',
  styleUrls: ['./ban-driver-dialog.component.scss'],
})
export class BanDriverDialogComponent {
  public accountName$: Observable<string>;

  public reasonControl = new FormControl();

  public networkActive$$ = new BehaviorSubject<boolean>(false);

  constructor(
    private matDialogRef: MatDialogRef<BanDriverDialogComponent>,
    private userService: UserService,
    private lmoDriverService: LmoDriverService,
    @Inject(MAT_DIALOG_DATA)
    public data: { driver: LmoDriver },
  ) {
    this.accountName$ = this.userService.userContract$.pipe(map((contract) => contract?.account?.name));
  }

  public async suspendDriver() {
    if (this.networkActive$$.value) {
      return;
    }
    try {
      this.networkActive$$.next(true);
      const success = await this.lmoDriverService.banDriver(this.data.driver.id, this.reasonControl.value);

      if (success) {
        this.matDialogRef.close();
      }
    } finally {
      this.networkActive$$.next(false);
    }
  }

  public closeDialog() {
    this.matDialogRef.close();
  }
}
